/* eslint-disable max-lines-per-function */
/* eslint-disable react/no-unescaped-entities */
import React, { useMemo } from 'react';
import {
  PartnerSOWRateCard,
  ServicePackageRateCardInfo,
  AddOnCategory
} from '@ad/ad_utils_react/src/components/business/TTCX/AddOn/types';
import { UserRegionEnum, UserRoleEnum } from '@/models/global';
import { RegionTextMap } from '../BusinessRelatedParams/consts';
import PackageTableSchema from './PackageTableSchema';
import NAPackageTableSchema from './NAPackageTableSchema';

export enum CardType {
  rateCard = 'rateCard',
  ttcxPackage = 'ttcxPackage'
}

function TTCXPackageCard(props: {
  cardType: CardType;
  region: UserRegionEnum;
  showRegion?: boolean;
  card?: PartnerSOWRateCard;
  userRole?: UserRoleEnum;
  partnerCanSupportRevShare?: boolean;
}) {
  const { cardType, region, showRegion = true, card, userRole, partnerCanSupportRevShare } = props;

  const netNewPackagesVCP = useMemo<ServicePackageRateCardInfo[]>(() => {
    // toDo need to handle single packageType from partner accepting

    if (cardType === CardType.rateCard) {
      return (card?.servicePackagesMap?.agency || []).filter((item) => item.serviceType === 0) || [];
    }
    return card?.servicePackages?.filter((item) => item.serviceType === 0) || [];
  }, [card]);

  const netNewPackagesCLP = useMemo<ServicePackageRateCardInfo[]>(() => {
    return (card?.servicePackagesMap?.creator || []).filter((item) => item.serviceType === 0) || [];
  }, [card]);

  const addOnsVCP = useMemo<AddOnCategory[] | undefined>(() => {
    if (cardType === CardType.rateCard) {
      return card?.addOnsMap?.agency;
    }
    return card?.addOns;
  }, [card]);

  const addOnsCLP = useMemo<AddOnCategory[] | undefined>(() => {
    return card?.addOnsMap?.creator;
  }, [card]);

  const repurposePackages = useMemo<ServicePackageRateCardInfo[]>(() => {
    // toDo need to handle single packageType from partner accepting

    if (cardType === CardType.rateCard) {
      return (card?.servicePackagesMap?.agency || []).filter((item) => item.serviceType === 1) || [];
    }
    return card?.servicePackages?.filter((item) => item.serviceType === 1) || [];
  }, [card]);

  if (region === UserRegionEnum.NA && cardType === CardType.rateCard && partnerCanSupportRevShare) {
    return (
      <div>
        {((netNewPackagesVCP?.length ?? 0) >= 1 || (repurposePackages?.length ?? 0) >= 1) && (
          <NAPackageTableSchema
            region={region}
            showRegion={showRegion}
            userRole={userRole}
            netNewPackages={netNewPackagesVCP}
            repurposePackages={repurposePackages}
            addOns={addOnsVCP}
            regionTextMap={RegionTextMap}
          />
        )}
        {(netNewPackagesCLP?.length ?? 0) >= 1 && (
          <NAPackageTableSchema
            region={region}
            showRegion={showRegion}
            userRole={userRole}
            netNewPackages={netNewPackagesCLP}
            repurposePackages={repurposePackages}
            addOns={addOnsCLP}
            regionTextMap={RegionTextMap}
            isCLP={true}
          />
        )}
      </div>
    );
  }
  return (
    <div>
      {((netNewPackagesVCP?.length ?? 0) >= 1 || (repurposePackages?.length ?? 0) >= 1) && (
        <PackageTableSchema
          cardType={cardType}
          region={region}
          showRegion={showRegion}
          userRole={userRole}
          netNewPackages={netNewPackagesVCP}
          repurposePackages={repurposePackages}
          addOns={addOnsVCP}
          regionTextMap={RegionTextMap}
        />
      )}
      {(netNewPackagesCLP?.length ?? 0) >= 1 && (
        <PackageTableSchema
          cardType={cardType}
          region={region}
          showRegion={showRegion}
          userRole={userRole}
          netNewPackages={netNewPackagesCLP}
          repurposePackages={repurposePackages}
          addOns={addOnsCLP}
          regionTextMap={RegionTextMap}
          isCLP={true}
        />
      )}
    </div>
  );
}

export default TTCXPackageCard;
